// Configuração do backend cloud (Supabase) — Fase 3 / shell cloud.
// A URL e a anon key são PÚBLICAS por design: a anon key vai no bundle de qualquer
// app Supabase e quem protege os dados é a RLS (+ as Edge Functions server-authority).
// Dá pra sobrescrever por variável de ambiente do Vite p/ apontar a outro projeto.
export const SUPABASE_URL =
  (import.meta.env.VITE_SUPABASE_URL as string | undefined) ??
  "https://msxxmdrahybmueababcr.supabase.co";

export const SUPABASE_ANON_KEY =
  (import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined) ??
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1zeHhtZHJhaHlibXVlYWJhYmNyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA2MzAzNDcsImV4cCI6MjA5NjIwNjM0N30.QrkW4fsq2Al2OoQJCaSFhSIvrr7MQ-_Ded-p5oc235Y";

// PowerSync (sync offline) — Instance URL do painel PowerSync (pública; o token do
// usuário é quem autoriza). Override por env se apontar a outra instância.
export const POWERSYNC_URL =
  (import.meta.env.VITE_POWERSYNC_URL as string | undefined) ??
  "https://6a22f09635ca576ca0da34ed.powersync.journeyapps.com";
